import { BCMSRecord, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIAmountInput, UIButton, UICheckbox } from "components/ui";
import Classes, { Account, UserAccount } from "model";

import "./styles.css";

export default function AddAlertBelowThresholdContent(props) {
    const navigate = useRoute();
    let { id } = useParams();
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    // START: These props are passed through capture components.
    let selectedUserAccountID = data.selectedUserAccountID ?? "0";
    let selectedUserAccountType = data.selectedUserAccountType ?? "email";

    if(data.id) {
        id = data.id;
    }
    // END: These props are passed through capture components.

    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const account = Account.initByType(id) ?? Account.initAll()[0];
    const userAccounts = UserAccount.initAll() ?? [];

    const { phones, emails } = userAccounts.reduce((result, { workPhoneNumber, emailAddress, id }) => {
        const phoneIsSelected = id === selectedUserAccountID && selectedUserAccountType === "phone";
        const emailIsSelected = id === selectedUserAccountID && selectedUserAccountType === "email";

        result.phones.push(<UICheckbox label={ workPhoneNumber } dataPoint={ `Add_Alert_User_Account_Phone_${ id }` } value={ phoneIsSelected } />);
        result.emails.push(<UICheckbox label={ emailAddress } dataPoint={ `Add_Alert_User_Account_Email_${ id }` } value={ emailIsSelected } />);

        return result;
    }, { phones: [], emails: [] })

    const onCancel = evt => navigate("/advancedAlerts/selectAccount");
    const onSubmit = evt => navigate("/advancedAlerts/manageAlerts", { state: { added: true } });

    return (
        <div className="add-alert-below-threshold-content">
            <p className="page-subtitle">Account Balance Below Threshold</p>

            <FormContainer className="small-form-width">
                <FormRowView>
                    <div className="flex-container flex-vertical account-details">
                        <p className="account-name">{ account.nickname }</p>
                        <p className="account-number">{ account.number }</p>
                        <p className="account-amount">{ account.currentBalance.format() }</p>
                    </div>
                </FormRowView>

                <FormRowView text="Amount *">
                    <UIAmountInput value={ data.amount } dataPoint="Add_Alert_Below_Threshold_Amount_Input" />
                </FormRowView>

                <FormRowView text="Recipients *" className="recipients-container">
                    <div className="flex-container flex-vertical">
                        { emails }
                        { phones }
                    </div>
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="secondary-button" text="Cancel" dataPoint="Add_Alert_Cancel_Button" onClick={ onCancel } />
                    <UIButton className="primary-button" text="Submit" dataPoint="Add_Alert_Submit_Button" onClick={ onSubmit } />
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  
});